import { AiOutlineArrowRight } from "react-icons/ai";

import "./NewsCard.scss";

interface NewsCardProps {
  title: string;
  text: string | React.ReactNode;
  image: string;
  date: string;
  link: string;
}

export const NewsCard = ({
  title,
  text,
  image,
  date,
  link,
}: NewsCardProps) => {
  return (
    <a href={link} className="news-card">
      <div className="news-card__image-wrapper">
        <img className="news-card__image" src={image} alt={title} loading="lazy" />
      </div>
      <div className="content">
        <div className="content__title">{title}</div>
        <div className="content__text">{text}</div>
        <div className="content__text content__date">{date}</div>
      </div>
      <AiOutlineArrowRight className="news-card__icon"/>
    </a>
  );
};
